import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import ErrorBanner from "../components/ui/ErrorBanner";
import SkeletonList from "../components/ui/SkeletonList";

import { IoMdArrowBack } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { RiInformation2Fill } from "react-icons/ri";

import { useNavigate } from "react-router-dom";
import { useLoading } from "../context/LoadingContext";
import { fetchCashBackList } from "../utils/api";
import FloatingMenu from "../components/FloatingMenu";

const CashBack = () => {
    const { t } = useTranslation();
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState("");

    const [cashbackLoading, setCashbackLoading] = useState(true);
    const [cashBackList, setCashBackList] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            setCashbackLoading(true);
            setErrorMessage("");

            try {
                const cashBackResponse = await fetchCashBackList();

                if (cashBackResponse.success && Array.isArray(cashBackResponse.data) && cashBackResponse.data.length > 0) {
                    setCashBackList(cashBackResponse.data);
                } else {
                    setCashBackList([]);
                }
            } catch (error) {
                setErrorMessage(t("pleaseTryLater"));
            } finally {
                setLoading(false);
                setCashbackLoading(false);
            }
        };

        loadData();
    }, [setLoading, t]);

    useEffect(() => {
        if (errorMessage) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [errorMessage]);

    return (
        <section className="page-shell">
            <div className="page-header">
                <div
                    className="cursor-pointer bg-secondary container-back-button text-color-blue rounded-full"
                    onClick={() => navigate("/")}
                >
                    <IoMdArrowBack className="size-sm" />
                    <span className="text-sm">
                        {t("backToLobby")}
                    </span>
                </div>
                <button className="cursor-pointer" onClick={() => navigate("/")}>
                    <IoClose className="size-lg text-color-blue" />
                </button>
            </div>

            <ErrorBanner message={errorMessage} />

            <div className="p-4">
                <p className="page-title-centered">
                    {t("cashBack")}
                </p>

                <div className="mb-6">
                    <div className="info-banner">
                        <RiInformation2Fill className="size-lg text-border-yellow" />
                        <div className="flex flex-col flex-grow">
                            <span className="text-xs text-white">
                                {t("DailyCashback")}.
                            </span>
                        </div>
                    </div>
                </div>

                {cashbackLoading ? (
                    <SkeletonList
                        rows={cashBackList.length || 1}
                        className="rounded-lg"
                    />
                ) : (
                    <div className="list-card">
                        {cashBackList.length > 0 ? (
                            cashBackList.map((cashback) => (
                                <div
                                    key={cashback.id}
                                    className="rate-row"
                                >
                                    <span className="text-sm flex-between">
                                        {cashback.product_name}
                                    </span>
                                    <span className="text-sm text-color-blue">
                                        {Number(cashback.rate).toFixed(2)} %
                                    </span>
                                </div>
                            ))
                        ) : (
                            <div className="empty-state">
                                {t("noCashbackFound")}
                            </div>
                        )}
                    </div>
                )}
            </div>

            <FloatingMenu />
        </section>
    );
};

export default CashBack;